import React, { useState } from 'react';
import Axios from 'axios';
import { Formik, Form } from 'formik';
import isEmpty from 'lodash.isempty';
import FInput from '../Inputs/FInput';
import { Modal } from './PartnersStyles';
import { UserConsumer } from '../context/User.context';
import validationSchema from './validationSchema';

const PartnersModal = ({ form, handleToggleModal, isModalOpen }) => {
  const { subtitle, title } = form;
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [formError, setFormError] = useState('');

  const submitForm = async (data, context) => {
    setIsLoading(true);

    // send email
    await Axios.post(`/api/backend/nwapi/partnerships/new-partner`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(() => setIsSent(true))
      .catch(err => {
        setIsSent(false);
        setFormError('There was an error submitting the form. Please try again.');
      })
      .then(() => setIsLoading(false));
  };

  return (
    <UserConsumer>
      {context => (
        <Modal isModalOpen={isModalOpen}>
          <Formik
            initialValues={{
              comment: '',
              companyName: '',
              email: '',
              firstName: '',
              lastName: '',
              phone: '',
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              submitForm(values, context);
              setSubmitting(true);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleReset,
              handleSubmit,
              isSubmitting,
              touched,
              values,
            }) => (
              <div className="modal-body">
                {!isSent ? (
                  <>
                    <button
                      className="close"
                      onClick={() => {
                        handleToggleModal();
                        handleReset();
                        setIsSent(false);
                        setIsLoading(false);
                      }}
                      onKeyDown={() => {
                        handleToggleModal();
                        handleReset();
                        setIsSent(false);
                        setIsLoading(false);
                      }}
                      type="button"
                    >
                      &times;
                    </button>
                    <h3>{title}</h3>
                    <p className="subtitle">{subtitle}</p>

                    <Form
                      onSubmit={handleSubmit}
                      className={isLoading ? 'is-loading' : ''}
                    >
                      <div className="row">
                        <div className="col-md-6 col-xs-12">
                          <div className="form-group">
                            {/* First Name */}
                            <FInput
                              id="firstName"
                              label="First Name"
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12">
                          <div className="form-group">
                            {/* Last Name */}
                            <FInput
                              id="lastName"
                              label="Last Name"
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-xs-12">
                          <div className="form-group">
                            {/* Email */}
                            <FInput
                              id="email"
                              label="Email"
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              type="email"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12">
                          <div className="form-group">
                            {/* Phone */}
                            <FInput
                              id="phone"
                              label="Phone"
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              type="tel"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            {/* Company Name */}
                            <FInput
                              id="companyName"
                              label="Company Name"
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            {/* Comment */}
                            <FInput
                              id="comment"
                              rows="5"
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              label="Comment"
                              type="textarea"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 text-center">
                          <button
                            type="submit"
                            className="submit btn btn-primary btn-block"
                            disabled={isSubmitting || !isEmpty(errors)}
                          >
                            Submit
                          </button>
                          <span className="submit-error">{formError}</span>
                        </div>
                      </div>
                    </Form>
                  </>
                ) : (
                  <div className="thanks-wrapper">
                    <button
                      className="close"
                      onClick={() => {
                        handleToggleModal();
                        handleReset();
                        setIsSent(false);
                        setIsLoading(false);
                      }}
                      onKeyDown={() => {
                        handleToggleModal();
                        handleReset();
                        setIsSent(false);
                        setIsLoading(false);
                      }}
                      type="button"
                    >
                      &times;
                    </button>
                    <h3>Thank you!</h3>
                    <p>We will be in touch with you soon.</p>
                  </div>
                )}
              </div>
            )}
          </Formik>
        </Modal>
      )}
    </UserConsumer>
  );
};

export default PartnersModal;
